/**
 * Adres metni oluşturur. AddressDetail string'ine BuildingNumber ve ApartmentNumber bilgilerini ekler.
 * Adres gösterimi yapılan tüm ekranlarda bu fonksiyon kullanılmalıdır.
 */
const formatAddressText = (
  addressDetail?: string,
  buildingNumber?: string,
  apartmentNumber?: string
): string => {
  let text = addressDetail || '';

  const parts: string[] = [];
  if (buildingNumber) {
    parts.push(`Bina No: ${buildingNumber}`);
  }
  if (apartmentNumber) {
    parts.push(`İç Kapı No: ${apartmentNumber}`);
  }

  if (parts.length > 0) {
    text = `${text} ${parts.join(' ')}`.trim();
  }

  return text;
};

export default formatAddressText;
